module.exports = __webpack_public_path__ + "static/media/14x152.ed969283.png";